import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import Select from "react-select";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import GooglePlace from "../GooglePlace";

import {
  Input,
  SelectInput,
  RenderInputFields,
  MultiReactSelectInput,
  SubmitButton,
  PhoneNumber,
} from "../Form/Form";

import { API } from "../../constant/api";

const Edit = (props) => {
  const { id } = props.match.params;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    unregister,
    watch,
    clearErrors,
    control,
  } = useForm();

  const history = useHistory();

  const imgArray = ["image/png", "image/jpeg", "image/jpg"];

  const [image, setImage] = useState("");
  const [businessImage, setBusinessImage] = useState("");
  const [positionData, setPositionData] = useState([]);
  const [carBrand, setCarBrand] = useState([]);
  const [personalAddress, setPersonalAddress] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  // const [country, setCountry] = useState([]);
  const [brands, setBrands] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [personalCity, setPersonalCity] = useState("");
  const [businessCity, setBusinessCity] = useState("");


  console.log("cityList",cityList)
  console.log("businessCity",businessCity)

  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const [isDocumentRemove, setIsDocumentRemove] = useState(false);

  const { response, request } = useRequest();
  const { response: responseFetchSeeker, request: requestFetchSeeker } =
    useRequest();
  const { response: positionRes, request: positionReq } = useRequest();
  const { response: brandRes, request: brandReq } = useRequest();
  // const { response: countryRes, request: countryReq } = useRequest();
  const { response: citySearchRes, request: citySearchReq } = useRequest();
  const [defaultData, setDefaultData] = useState([]);

  useEffect(() => {
    brandReq("GET", "brand");
    positionReq("GET", "position");
    citySearchReq("GET", `city/get-all`);
    // countryReq("GET", "country/get-all-countries");
  }, []);

  useEffect(() => {
    if (brandRes) {
      setCarBrand(brandRes.data);
    }
  }, [brandRes]);

  useEffect(() => {
    if (citySearchRes) {
      const arr = [];
      if (citySearchRes?.cities.length > 0) {
        citySearchRes?.cities?.map((val) =>
          arr.push({
            value: val._id,
            label: val.name,
          })
        );
        setCityList(arr);
      }
    }
  }, [citySearchRes]);

  // useEffect(() => {
  //   if (countryRes) {
  //     setCountry(countryRes.countries);
  //   }
  // }, [countryRes]);

  useEffect(() => {
    if (positionRes) {
      setPositionData(positionRes.data);
    }
  }, [positionRes]);

  useEffect(() => {
    if (response) {
      toast.success("Vendor has been updated successfully.");
      history.push("/stores");
    }
  }, [response]);

  useEffect(() => {
    if (id) {
      requestFetchSeeker("GET", `vendor/${id}`);
      document.title = `Edit Store - Easyspare`;
    }
  }, [id]);

  useEffect(() => {
    if (responseFetchSeeker) {
      const {
        firstName,
        lastName,
        contact,
        countryCode,
        profilePic,
        email,
        position,
        dob,
      } = responseFetchSeeker.vendor;
      const {
        businessAddress,
        businessName,
        attachments,
        carBrand,
        personalAddress,
        _id,
        userId,
      } = responseFetchSeeker.vendorDetails;
      if (profilePic) {
        setImage(`${API.PORT}/${profilePic}`);
      }

      if (attachments.length > 0) {
        setBusinessImage(`${API.PORT}/${attachments[0]}`);
      }
      setValue("id_data", _id);
      setValue("userId", userId);
      setPersonalAddress(personalAddress.address);
      setBusinessAddress(businessAddress.address);
      setValue("firstName", firstName);
      setValue("lastName", lastName);
      // setValue("contact", contact);
      setValue("contact",countryCode+""+contact);
      setValue("countryCode", countryCode);
      setValue("email", email);
      setValue("dob", moment(dob).format("YYYY-MM-DD"));
      setValue("businessName", businessName);
      setTimeout(() => {
        setValue("position", position);
        let options = [];
        if (carBrand && carBrand?.length > 0) {
          carBrand?.forEach((obj) => {
            options.push({
              label: obj.name,
              value: obj._id,
            });
          });
          setBrands(options);
        }
        setValue("carBrand", options);
        setValue("country", personalAddress.country);
        setValue("businessCountry", businessAddress.country);
        setPersonalCity(personalAddress?.city);
        setBusinessCity(businessAddress?.city?._id);
      }, 200);

      setValue("address", personalAddress.address);
      setValue("state", personalAddress.state);
      setValue("postal_code", personalAddress.postal_code);
      setValue("businessAddress", businessAddress.address);
      setValue("businessState", businessAddress.state);
      setValue("business_postal_code", businessAddress.postal_code);
    }
  }, [responseFetchSeeker]);

  const displayImageHandler = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
    setIsProfilePicRemove(false);
  };

  const displayBusinessImageHandler = (e) => {
    setBusinessImage(URL.createObjectURL(e.target.files[0]));
    setIsDocumentRemove(false);
  };
  const handleRemoveMedia = () => {
    setIsProfilePicRemove(true);
    setValue("profilePic", "");
    setImage("");
  };

  const handleRemoveBusinessMedia = () => {
    setIsDocumentRemove(true);
    setValue("document", "");
    setBusinessImage("");
  };
  const saveAddressHandler = (address, geoLocation, key) => {
    setValue("address", address);
  };
  const businessAddressHandler = (address, geoLocation, key) => {
    setValue("businessAddress", address);
  };

  const customOtherLoactionDetailHandler = (postalCode, city, state, key) => {
    // setValue("city", city);
    setValue("state", state);
    setValue("postal_code", postalCode);
  };
  const businessOtherLoactionDetailHandler = (postalCode, city, state, key) => {
    // setValue("businessCity", city);
    setValue("businessState", state);
    setValue("business_postal_code", postalCode);
  };

  const onSubmit = (data) => {
    let {
      businessName,
      businessAddress,
      businessCountry,
      // businessCity,
      businessState,
      business_postal_code,
      firstName,
      lastName,
      email,
      countryCode,
      contact,
      // dob,
      position,
      profilePic,
      address,
      // city,
      state,
      postal_code,
      carBrand,
      businessProfile,
      country,
      id_data,
      userId,
    } = data;

    // if (dob == "Invalid date") {
    //   dob = "";
    // }

    if (email) {
      email = email.toLowerCase();
    }

    let itemArray = [];

    carBrand.map((item) => {
      itemArray.push(`${item.value}`);
    });

    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("contact", contact.replace(countryCode, ""));
    formData.append("countryCode", countryCode);
    // formData.append("dob", dob);
    // formData.append("city", city);
    if (personalCity) {
      formData.append("city", personalCity);
    }
    formData.append("country", country);
    formData.append("state", state);
    formData.append("address", address);
    formData.append("postal_code", postal_code);
    formData.append("position", position);
    formData.append("carBrand", JSON.stringify(itemArray));
    formData.append("businessName", businessName);
    // formData.append("businessCity", businessCity);
    if (businessCity) {
      formData.append("businessCity", businessCity);
    }
    formData.append("businessCountry", businessCountry);
    formData.append("businessState", businessState);
    formData.append("businessAddress", businessAddress);
    formData.append("business_postal_code", business_postal_code);
    formData.append("id", id_data);
    formData.append("userId", userId);

    formData.append("isProfilePicRemove", isProfilePicRemove);
    formData.append("isDocumentRemove", isDocumentRemove);

    if (profilePic && profilePic[0]) {
      const profilePicType = profilePic[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select image only in profile pic");
        return;
      } else {
        formData.append("profilePic", profilePic[0]);
      }
    }

    if (businessProfile && businessProfile[0]) {
      const profilePicType = businessProfile[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select image type only");
        return;
      } else {
        formData.append("businessProfile", businessProfile[0]);
      }
    }

    request("PUT", "vendor", formData);
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "First Name",
        type: "text",
        name: "firstName",
        registerFields: {
          required: true,
          onChange: (v) =>
            setValue("firstName", v.target.value.replace(/[^a-zA-Z]/g, "")),
        },
      },
      {
        Component: Input,
        label: "Last Name",
        type: "text",
        name: "lastName",
        registerFields: {
          required: true,
          onChange: (v) =>
            setValue("lastName", v.target.value.replace(/[^a-zA-Z]/g, "")),
        },
      },
      {
        Component: Input,
        label: "Email",
        type: "email",
        name: "email",
        registerFields: {
          required: true,
          pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          setValueAs: (v) => v.trim(),
        },
        registerFieldsFeedback: {
          pattern: "The email field must be a valid email address.",
        },
      },
      {
        Component: PhoneNumber,
        label: "Contact",
        type: "number",
        name: "contact",
        control: control,
        setValue: setValue,
        registerFields: {
          required: true,
          pattern: {
            value: /^[0-9][0-9]{7,14}$/,
          },
        },
        registerFieldsFeedback: {
          pattern: "Please enter valid 8-15 digit contact number.",
        },
      },
      // {
      //   Component: Input,
      //   label: "DOB",
      //   type: "date",
      //   name: "dob",
      //   isDate: true,
      //   control: control,
      //   max: new Date().toISOString().split("T")[0],
      //   min: "1970-01-01",
      //   registerFields: {
      //     required: false,
      //   },
      // },
      {
        Component: Input,
        label: "Profile Pic",
        type: "file",
        name: "profilePic",
        registerFields: {
          required: false,
        },
        handleMedia: displayImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image && (
          <>
            <img
              src={image}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveMedia} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },
      // {
      //   Component: SelectInput,
      //   label: "Country",
      //   name: "country",
      //   registerFields: {
      //     required: true,
      //   },
      //   children: (
      //     <>
      //       <option value="">Select</option>
      //       {country?.map((item) => {
      //         return (
      //           <option key={item._id} value={item.value}>
      //             {item.label}
      //           </option>
      //         );
      //       })}
      //     </>
      //   ),
      // },
    ],
  ];

  const InputFieldsBusiness = [
    [
      {
        Component: Input,
        label: "Business Name",
        type: "text",
        name: "businessName",
        registerFields: {
          required: true,
        },
      },
      {
        Component: SelectInput,
        label: "Position",
        name: "position",
        registerFields: {
          required: true,
        },
        children: (
          <>
            <option value="">Select</option>
            {positionData.map((item) => {
              return (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              );
            })}
          </>
        ),
      },

      {
        Component: MultiReactSelectInput,
        label: "Car Brand",
        name: "carBrand",
        registerFields: {
          required: true,
        },
        control: control,
        isMultiple: true,
        defaultValue: defaultData,
        options:
          carBrand &&
          carBrand.map((item) => {
            return { value: item._id, label: item.name };
          }),
      },
      // {
      //   Component: SelectInput,
      //   label: "Car Brands",
      //   name: "carBrand",
      //   registerFields: {
      //     required: true,
      //   },
      //   isEdit: true,
      //   children: (
      //     <>
      //       <option value="">Select</option>
      //       {carBrand.map((item) => {
      //         return (
      //           <option key={item._id} value={item._id}>
      //             {item.name}
      //           </option>
      //         );
      //       })}
      //     </>
      //   ),
      // },
      {
        Component: Input,
        label: "Document",
        type: "file",
        name: "businessProfile",
        colClass: "col-6",
        registerFields: {
          required: false,
        },
        handleMedia: displayBusinessImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: businessImage && (
          <>
            <img
              src={businessImage}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveBusinessMedia} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },
      // {
      //   Component: SelectInput,
      //   label: "Country",
      //   name: "businessCountry",
      //   registerFields: {
      //     required: true,
      //   },
      //   children: (
      //     <>
      //       <option value="">Select</option>
      //       {country?.map((item) => {
      //         return (
      //           <option key={item._id} value={item.value}>
      //             {item.label}
      //           </option>
      //         );
      //       })}
      //     </>
      //   ),
      // },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Store"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/stores", name: "Back To stores" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div class="card-header">
              <h3 class="card-title">Edit Store</h3>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div class="accordion" id="accordionExample">
                      <div class="card">
                        <div class="card-header" id="headingOne">
                          <h2 class="mb-0">
                            <button
                              class="btn btn-link btn-block text-left"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              Personal Details
                            </button>
                          </h2>
                        </div>

                        <div
                          id="collapseOne"
                          class="collapse show"
                          aria-labelledby="headingOne"
                          data-parent="#accordionExample"
                        >
                          <div class="card-body">
                            <RenderInputFields
                              InputFields={InputFields}
                              errors={errors}
                              register={register}
                            />
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Address
                                    </label>
                                    <GooglePlace
                                      saveAddress={saveAddressHandler}
                                      setValue={setValue}
                                      defaultAddress={personalAddress}
                                      customOtherLoactionDetailHandler={
                                        customOtherLoactionDetailHandler
                                      }
                                      type="personal"
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      name="country"
                                      className="form-control"
                                      {...register("country")}
                                    />
                                  </div>
                                </div>
                              </div> */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">City</label>
                                    {/* <input
                                      type="text"
                                      name="city"
                                      className="form-control"
                                      {...register("city")}
                                    /> */}
                                    <Controller
                                      control={control}
                                      rules={{ required: false, minLength: 1 }}
                                      name="city"
                                      className="form-control"
                                      render={({
                                        field: { onChange, value, ref },
                                      }) => (
                                        <Select
                                          options={cityList}
                                          value={cityList.filter(function (
                                            option
                                          ) {
                                            return (
                                              option.label == personalCity
                                            );
                                          })}
                                          onChange={(e) => {
                                            setPersonalCity(e.label);
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">State</label>
                                    <input
                                      type="text"
                                      name="state"
                                      className="form-control"
                                      {...register("state")}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Zipcode
                                    </label>
                                    <input
                                      type="text"
                                      name="postal_code"
                                      className="form-control"
                                      {...register("postal_code")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="headingTwo">
                          <h2 class="mb-0">
                            <button
                              class="btn btn-link btn-block text-left"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              Business Details
                            </button>
                          </h2>
                        </div>

                        <div
                          id="collapseTwo"
                          class="collapse show"
                          aria-labelledby="headingTwo"
                          data-parent="#accordionExample"
                        >
                          <div class="card-body">
                            <RenderInputFields
                              InputFields={InputFieldsBusiness}
                              errors={errors}
                              register={register}
                            />
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Address
                                    </label>
                                    <GooglePlace
                                      saveAddress={businessAddressHandler}
                                      setValue={setValue}
                                      defaultAddress={businessAddress}
                                      businessOtherLoactionDetailHandler={
                                        businessOtherLoactionDetailHandler
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`businessCountry`)}
                                    />
                                  </div>
                                </div>
                              </div> */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">City</label>
                                    {/* <input
                                      type="text"
                                      className="form-control"
                                      {...register(`businessCity`)}
                                    /> */}
                                    <Controller
                                      control={control}
                                      rules={{ required: false, minLength: 1 }}
                                      name="businessCity"
                                      className="form-control"
                                      render={({
                                        field: { onChange, value, ref },
                                      }) => (
                                        <Select
                                          options={cityList}
                                          value={cityList.find(function (
                                            option
                                          ) {
                                            return (
                                              option.value == businessCity
                                            );
                                          })}
                                          onChange={(e) => {
                                            setBusinessCity(e.value);
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">State</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`businessState`)}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-input-box">
                                    <label className="form-label">
                                      Zipcode
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`business_postal_code`)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
